import axios from "axios";
import { SessionStore } from "../../../types/store";
import { newAbortSignal } from "../../../utils";

const BASE_URL = `${process.env.REACT_APP_BACKEND_URL}/captures`;
export const downloadMonitoringRecordsTemplateFile = async (
  filename: string,
  captureId: number,
): Promise<void> => {
  const session: SessionStore | undefined = JSON.parse(
    localStorage.getItem("session") || "{}",
  );

  const res = await axios.get<Blob>(`${BASE_URL}/${captureId}/monitoring/template`, {
    headers: {
      "x-access-token": session?.accessToken,
    },
    responseType: 'blob',
    timeout: Number.parseInt(`${process.env.REACT_APP_AXIOS_TIME_OUT}`),
    signal:
      AbortSignal.timeout === undefined
        ? newAbortSignal(Number(process.env.REACT_APP_AXIOS_TIME_OUT))
        : AbortSignal.timeout(Number(process.env.REACT_APP_AXIOS_TIME_OUT)),
  });

  const safeFilename = filename.replaceAll(/[^a-zA-Z0-9_.-]/g, "_");

  const blob = new Blob([res.data]);
  const url = globalThis.URL.createObjectURL(blob);

  const link = document.createElement('a');
  link.href = url;
  link.setAttribute('download', safeFilename);
  link.click();
  globalThis.URL.revokeObjectURL(url);
};
